import { CLIENTS } from "@/data/mock";
import { Search, Plus } from "lucide-react";

export default function AdminClients() {
  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <div className="eyebrow">// Clients</div>
          <h1 className="display-lg text-silver-50 mt-2">Client Roster</h1>
        </div>
        <button className="btn-primary"><Plus size={14} /> New client</button>
      </div>
      <div className="panel mt-8 p-4 flex items-center gap-3">
        <Search size={16} className="text-silver-300" />
        <input
          className="flex-1 bg-transparent outline-none text-silver-100 placeholder:text-silver-300"
          placeholder="Search by name, industry, directive…"
        />
      </div>
      <div className="mt-6 grid gap-4">
        {CLIENTS.map((c) => (
          <div key={c.id} className="panel p-6 flex items-center gap-6">
            <div className="h-14 w-14 rounded-md bg-brand-blue/15 border border-brand-blue/40 flex items-center justify-center font-display font-extrabold text-brand-blue">
              {c.name.split(" ").map((w) => w[0]).join("").slice(0, 2)}
            </div>
            <div className="flex-1">
              <div className="font-display font-semibold text-silver-50 text-lg">{c.name}</div>
              <div className="text-silver-300 text-sm">{c.industry} · {c.directive}</div>
            </div>
            <div className="text-center">
              <div className="eyebrow">// BSS</div>
              <div className={`mt-1 font-display font-extrabold text-2xl ${c.bss >= 75 ? "text-brand-blue" : c.bss >= 60 ? "text-silver-100" : "text-brand-red"}`}>{c.bss}</div>
            </div>
            <div className="text-center">
              <div className="eyebrow">// Stage</div>
              <div className="mt-1 font-mono text-lg text-silver-100">{c.stage}/11</div>
            </div>
            <div className="min-w-[140px]">
              <div className="eyebrow">// Status</div>
              <div className="mt-1 text-sm text-silver-100">{c.status}</div>
            </div>
            <button className="btn-ghost">Open</button>
          </div>
        ))}
      </div>
    </div>
  );
}
